import {FC} from 'react'
import {UsersList} from './UsersList'

const UsersListWrapper: FC = () => {
  return <UsersList />
}

export {UsersListWrapper}
